import { z } from 'zod';

const MeetingYggReportSchema = z.object({
    id: z.string().min(1).optional(),
    name: z.string().min(1).optional(),
    url: z.string().optional(),
    storageKey: z.string().optional(),
    mimeType: z.string().optional(),
    size: z.union([z.number(), z.string()]).optional(),
    uploadedAt: z.union([z.string(), z.date()]).optional(),
});

export const MeetingSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    title: z.string().min(1),
    date: z.string().or(z.date()),
    scheduledDate: z.string().or(z.date()).optional(),
    isManagementReview: z.union([z.boolean(), z.string()]).default(false),
    participants: z.string().optional(),
    additionalParticipants: z.string().optional(),
    agenda: z.string().optional(),
    additionalAgenda: z.string().optional(),
    topicsDiscussed: z.string().optional(),
    decisions: z.string().optional(),
    reviewScope: z.array(z.string()).optional(),
    reviewInputs: z.record(z.any()).optional(),
    previousReviewActions: z.array(z.unknown()).optional(),
    yggReports: z.array(MeetingYggReportSchema).optional(),
    status: z.string().default('scheduled'),
    customFields: z.record(z.unknown()).optional(),
    createdAt: z.union([z.string(), z.date()]).optional(),
    updatedAt: z.union([z.string(), z.date()]).optional(),
});
export const CreateMeetingSchema = MeetingSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateMeetingSchema = MeetingSchema.partial();
export const MeetingFormSchema = MeetingSchema;

export const DiscardMeetingYggReportSchema = z.object({
    storageKey: z.string().min(1).optional(),
    url: z.string().min(1).optional(),
}).refine((value) => Boolean(value.storageKey || value.url), {
    message: 'storageKey or url is required',
});
